import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=44ef10ba&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=44ef10ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef10ba",
  null
  
)

export default component.exports